import { isEqual } from "lodash-es";
class Match {
  constructor(props) {
    Object.assign(this, props);
    this.value = this.obj[this.prop];
  }
  toString() {
    const { path, type } = this;
    return `${path} -> (${type}) ${this.logValue()}`;
  }
  logValue() {
    const val = this.value;
    const isPrimitive = (x) => Object(x) !== x;
    return isPrimitive(val) || Array.isArray(val) ? val : {}.toString.call(val);
  }
  log() {
    console.info(this.toString());
  }
}
const GLOBAL = typeof window == "object" ? window : global;
export default function searchWholeObjByName(what, where) {
  const searchBy = (what2, where2, prop) => what2 == prop;
  let data;
  let alreadySeen;
  const path = where == GLOBAL ? "GLOBAL" : "SRC";
  const queue = [{ where, path }];
  const seen = [];
  const matches = [];
  matches.log = function() {
    this.forEach((m) => m.log());
  };
  while (data = queue.pop()) {
    const { where: where2, path: path2 } = data;
    for (const prop in where2) {
      try {
        if (where2.hasOwnProperty(prop)) {
          if ([where2[prop]] == "[object Object]") {
            for (let i = -1; seen[++i] && !(alreadySeen = isEqual(seen[i].where, where2[prop]) && seen[i]); ) ;
            if (!alreadySeen) {
              data = { where: where2[prop], path: `${path2}.${prop}` };
              queue.push(data);
              seen.push(data);
            }
          }
          if (searchBy(what, where2, prop)) {
            const type = alreadySeen ? `<${alreadySeen.path}>` : typeof where2[prop];
            const match = new Match({
              path: `${path2}.${prop}`,
              obj: where2,
              prop,
              type
            });
            matches.push(match);
          }
        }
      } catch (e) {
      }
    }
  }
  return matches;
}
export function searchWholeObjByNameSimple(what, where) {
  return searchWholeObjByName(what, where)?.[0]?.value?.[0];
}
export function searchWholeObjByNameSimpleArray(what, where) {
  return searchWholeObjByName(what, where)?.[0]?.value;
}
